export const NAME = 'core-modal';
